import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';

var CityPanelItem = function CityPanelItem(props) {
  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var city = props.city,
      onSelect = props.onSelect;
  var cityPickerPrefixCls = getPrefixCls(prefixCls, 'city-picker');
  var cls = classNames("".concat(cityPickerPrefixCls, "-city-table-cell"));

  var handleCitySelect = function handleCitySelect() {
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(city);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    key: city.id,
    title: city.name,
    onClick: handleCitySelect
  }, city.name);
};

export default CityPanelItem;